<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <telegram-form
      ref="form"
      @submit="submitHandle"
    ></telegram-form>
  </sliderBarDialogShell>
</template>

<script>
import { saveTelegramConfig } from '@/api/sys/robitConfig/telegram'
import telegramForm from '@/components/sys/robitCofig/telegram/telegramForm'

export default {
  name: 'addTelegram',
  components:{
    telegramForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增Telegram推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        saveTelegramConfig(formData).then((res) => {
          this.$refs.form.$refs.form.clearValidate();
          this.$refs.form.$refs.form.resetFields();
            this.$emit('add-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
